const landingPages = (data, gsap, mm, smoother, Swiper, Parallax, Navigation, Pagination, FreeMode, ScrollTrigger) => {
  
  /***************************************************************
    PARALLAX ITEMS
  ***************************************************************/
 
  const $container = $(data.next.container);
  const $introPara = $container.find('.lp-intro-main .post-copy');
  const $introImgPara = $container.find('.lp-callout-list-images .rgb');
  const $calloutListPara = $container.find('.lp-callout-list-item');
  const $teamsContentPara = $container.find('.lp-teams-content .p-lg');
  const $teamsListPara = $container.find('.teams-list > div');
  const $hiringImgPara = $container.find('.lp-hiring .rgb');
  
  mm.add("(min-width: 768px)", () => {
    
    if ($introPara.length) {
      smoother.effects($introPara, {speed: 1.25});
    }
    
    if ($introImgPara.length) {
      $introImgPara.each(function (index, el) {
        smoother.effects(el, {speed: 1 + index * 0.1});
      });
    }
    
    if ($calloutListPara.length) {
      $calloutListPara.each(function (index, el) {
        smoother.effects(el, {lag: 0.2 + index * 0.1});
      });
    }
    
    if ($teamsContentPara.length) {
      smoother.effects($teamsContentPara, {speed: 0.9});
    }
    
    if ($teamsListPara.length) {
      $teamsListPara.each(function (index, el) {
        smoother.effects(el, {lag: 0.05 + index * 0.1});
      });
    }
    
    if ($hiringImgPara.length) {
      $hiringImgPara.each(function (index, el) {
        smoother.effects(el, {speed: 1 + index * 0.1});
      });
    }
    
  }, '.page-template-page-landing-pages');
  
  /***************************************************************
    CS STATS ANIMATION
  ***************************************************************/
  
  const $statTexts = $container.find('.lp-highlight-item span.h2');
  const $trigger = $container.find('.lp-highlight-items');
  
  if ($statTexts) {

    $statTexts.each(function() {

      const $this = $(this);
      const $text = $this.text();

      gsap.to($this, {
        scrambleText: {
          text: $text,
          chars: "#$@",
          revealDelay:1,
          tweenLength:false,
        }
      })

      gsap.to($this, {
        scrollTrigger: {
          trigger: $trigger,
          start: "top center",
        },
        scrambleText:{
          text: $text, 
          chars:"#$@", 
          speed:0.4
        },
        onStart: function() {
          $this.addClass('tweening');
        },
        onComplete: function() {
          $this.removeClass('tweening');
        }
      });

    });

  }
  
  /***************************************************************
    TECH ACCORDION
  ***************************************************************/
 
  const $accordions = $('.tech-accordion-btn');

  if ( $accordions.length ) {

    const $closedaccordion = $('.tech-accordion-btn:not(.active)');

    $closedaccordion.on('click', function() {

      const close = $('.tech-accordion-btn.active'),
            collapse = $('.lp-stack-section .expand'),
            icn = $('.lp-stack-section .accordion-icon'),
            box = $('.lp-stack-section .accordion-box'),
            $clicked = $(this),
            $parent = $clicked.parent(),
            $expand = $clicked.next('.expand'),
            $minus = $clicked.find('.accordion-icon'),
            $logos = $clicked.parent().find('.stack-logo');
            
      let totalHeight = 0,
          duration = 0.4;


      if ( $clicked.hasClass('active') ) {
        
        if ($logos.length) {
          gsap.to($logos, {duration: 0.15, opacity: 0, stagger: -0.02, onComplete: () => {
            gsap.to($expand, {height: 0, duration: 0.6, ease: 'circ.out', onComplete: () => {
              $clicked.add($expand).add($minus).add($parent).removeClass('active');
              ScrollTrigger.refresh(true);
            }});
          }});
        } else {
          gsap.to($expand, {height: 0, duration: 0.6, ease: 'circ.out', onComplete: () => {
            $clicked.add($expand).add($minus).add($parent).removeClass('active');
            ScrollTrigger.refresh(true);
          }});
        }

      } else {
        
        let $currentLogos = $('.expand.active').find('.stack-logo');
        
        if ($currentLogos.length) {
          gsap.to($currentLogos, {duration: 0.15, opacity: 0, stagger: -0.02, onComplete: () => {
            
            setTimeout(() => {
              close.add(collapse).add(icn).add(box).removeClass('active');
              gsap.to(collapse, {height: 0, duration: 0.3, ease: 'circ.out', onComplete: function() {
                $expand.children().each(function(){
                  totalHeight = totalHeight + $(this).outerHeight(true);
                });
                totalHeight += ($expand.children('ul, ol').length * 15);

                if ( totalHeight <= 98 ) {
                  duration = 0.5;
                } else if ( totalHeight > 98 && totalHeight < 118 ) {
                  duration = 0.6;
                } else {
                  duration = 0.4;
                }

                gsap.to($expand, {height: totalHeight, duration: duration, ease: 'circ.out', autoRound: false, onComplete: function() {
                  if ($logos.length) {
                    gsap.to($logos, {duration: 0.3, opacity: 1, stagger: 0.05});
                  }
                  ScrollTrigger.refresh(true);
                }});
                $clicked.add($expand).add($minus).add($parent).addClass('active');

              }});
            }, 300);
            
          }});
        } else {
          
          close.add(collapse).add(icn).add(box).removeClass('active');
          gsap.to(collapse, {height: 0, duration: 0.3, ease: 'circ.out', onComplete: function() {
            $expand.children().each(function(){
              totalHeight = totalHeight + $(this).outerHeight(true);
            });
            totalHeight += ($expand.children('ul, ol').length * 15);

            if ( totalHeight <= 98 ) {
              duration = 0.5;
            } else if ( totalHeight > 98 && totalHeight < 118 ) {
              duration = 0.6;
            } else {
              duration = 0.4;
            }

            gsap.to($expand, {height: totalHeight, duration: duration, ease: 'circ.out', autoRound: false, onComplete: function() {
              if ($logos.length) {
                gsap.to($logos, {duration: 0.3, opacity: 1, stagger: 0.05});
              }
              ScrollTrigger.refresh(true);
            }});
            $clicked.add($expand).add($minus).add($parent).addClass('active');

          }});
          
        }

      }

    });

  }
  
  /***************************************************************
    TEAM CAROUSEL
  ***************************************************************/
 
  const lpTeamSwiper = new Swiper('.lpTeam', {
    modules: [Navigation, Pagination, Parallax, FreeMode],
    speed: 1000,
    autoHeight: true,
    parallax: true,
    freeMode: {
      enabled: true,
      sticky: true,
    },
    pagination: {
      el: ".lp-team-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".lp-team-next",
      prevEl: ".lp-team-prev",
    },
  });
  
}

export {
  landingPages
};
